"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var material_kit_pro_react_1 = require("../../../../assets/jss/material-kit-pro-react");
var styles = function (theme) {
    return (0, styles_1.makeStyles)({
        root: __assign(__assign({}, material_kit_pro_react_1.container), { display: 'flex', flex: 1, flexDirection: 'column' }),
        mainDiv: {
            margin: theme.spacing(0.5, 2, 0, 2)
        },
        mainDivAlt: {
            marginTop: theme.spacing(0.5)
        },
        profileBackdrop: {
            padding: theme.spacing(3, 4, 0, 4),
            backgroundColor: theme.palette.grey[200]
        },
        bottomSpacing: {
            marginBottom: theme.spacing(1)
        },
        titleBottomSpacing: {
            marginBottom: theme.spacing(4)
        },
        profileBottomSpacing: {
            marginBottom: theme.spacing(6)
        },
        buttonContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch'
        },
        buttonStyle: {
            padding: theme.spacing(2, 0, 2, 0),
            borderRadius: theme.spacing(0.5)
        }
    });
};
exports.default = styles;
//# sourceMappingURL=styles.js.map